/**
 * TRITURATION RESOLVER (MEV5)
 * Logic for solid-food lag phase (grinding period).
 * Model: Modified Power Exponential (MPE) (2024 Standard)
 */

import { V5_CONSTANTS } from '../constants';

export const TriturationResolver = {
    
    /**
     * Calculates the time-dependent lag multiplier for gastric emptying.
     * @param minsSinceMeal Minutes passed since the specific meal started
     * @param totalCalories Total energy density of the meal event (Phase 3.2)
     * @returns 0.0 (Fully Lagged) to 1.0 (Fully Liquid/Emptying)
     */
    getLagMultiplier(minsSinceMeal: number, totalCalories: number = 500): number {
        if (minsSinceMeal < 0) return 1.0;

        // MPE Equation: 1 - e^{-(kt)^beta}
        const k = 0.02; // Empirical base for athlete digestion
        
        // DYNAMIC BETA SCALING (Phase 3.2)
        // High calorie density = higher trituration resistance.
        let beta = 1.2; 
        if (totalCalories > 800) beta = 1.2 + Math.min(0.6, (totalCalories - 800) / 1000);
        if (totalCalories < 200) beta = 1.0;
        
        const multiplier = 1 - Math.exp(-Math.pow(k * minsSinceMeal, beta));
        
        return Math.max(0, Math.min(1, multiplier));
    }
};
